import { Route } from 'types/route.type';
import ListNutrients from './list-nutrients';

export const routes: Route[] = [
  {
    path: '/feed-management/nutrients',
    component: ListNutrients,
    id: 'feedManagement.navigation.listNutrients',
  },
];
